import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { User } from '../models/user';
import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ErrorHandlingService } from '../services/error-handling.service';
import { ERROR_DISPLAY_DURATION, SKIP_ERROR_TOAST, SKIP_GLOBAL_ERROR_HANDLING } from '../constants/http-context-tokens';
import { createApiError } from '../models/api-error';

let errorMessages: string[] = [];

export const OneApiAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const user = inject(User);
  const router = inject(Router);
  const notification = inject(NotificationService);
  const errorHandlingService = inject(ErrorHandlingService);


  const authReq = req.clone({
    withCredentials: true,
    setHeaders: {
      Authorization: `Bearer ${user?.access_token || ''}`,
    },
  });

  return next(authReq).pipe(
    catchError((err) => {
      // The caller handles this service's errors itself (e.g. CASI): no toast, no logout.
      if (req.context.get(SKIP_GLOBAL_ERROR_HANDLING)) {
        return throwError(() => err);
      }

      console.log(err);

      let errorMessage = 'An error occurred. Please try again.';

      if (err.error) {
        if (typeof err.error === 'object') {
          errorMessage = errorHandlingService.flattenErrorMessages(err.error);
        } else {
          errorMessage = err.error;
        }
      }

      // Callers that handle some errors themselves opt out of the global toast
      // for those; the error is still rethrown below.
      const skipToast = req.context.get(SKIP_ERROR_TOAST)(err.status, err.error);

      if(!skipToast && errorMessages.indexOf(errorMessage) < 0) {
        // Get the error display duration from the request context
        const hideAfter = req.context.get(ERROR_DISPLAY_DURATION);
        
        notification.show({
          content: errorMessage,
          cssClass: 'error-notification',
          animation: { type: 'fade', duration: 400 },
          position: { horizontal: 'center', vertical: 'top' },
          type: { style: 'error', icon: true },
          hideAfter: hideAfter,
        });

        errorMessages.push(errorMessage);
        setTimeout(() => {
          removeMessage(errorMessages, errorMessage);
        }, 5000);
      }



      console.log(errorMessages);
      if (err.status === 401) {
        console.log('authInterceptor 401');
        router.navigate(['/auth/login']);
      }

      if (err.status === 400) {
        console.log('authInterceptor 400');
        return throwError(() => createApiError(errorMessage, err.status, err.error));
      }

      return throwError(() => createApiError(errorMessage, err.status, err.error));
    }),
  );
};

function removeMessage(array: string[], item: string) {
  var i = array.length;

  while (i--) {
    if (array[i] === item) {
      array.splice(i, 1);
    }
  }
}
